<template>
    <div class="container container-fluid">
        <h1 class="page-heading mb-0">Card</h1>
        <div class="row">

            <!-- Alert Error     -->
            <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                    <span class="icon icon-error" aria-hidden="true">!</span>
                    <span class="sr-only">Error:</span>
                    Enter a valid email address
                </div>
            </div>
            <!-- End Alert Error -->
            <div class="col-12">
            <aha-card-selector title="Ready to volunteer?" data="" buttonText="" buttonRemoveText="" description="Take a look at these opportunities and make your selections.">
                <template v-slot:filters>
                    <aha-card-selector-filter title="Interested in Youth Volunteer?" description="Made for ages 18 & under" name="youth"/>
                </template>
                <aha-selection-card id="{27822E14-B366-43C3-A3CB-EC442AEC22F7}"
                                    title="Advocate for Healthcare"
                                    img="https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/voting.png?h=200&amp;w=266&amp;hash=3C626A776B12C6D65AF2C6B47A1DB480A5F0BE83"
                                    description="Description"
                                    flags="adults"
                                    categoryTitle="Hands only CPR"
                                    mediaLink=""
                                    downloadLink=""
                                    ></aha-selection-card>
                <aha-selection-card id="{DD4B4F54-F12E-489B-95FE-2EBCBC1ABB29}"
                                    title="Advocate for Change"
                                    img="https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/voting.png?h=200&amp;w=266&amp;hash=3C626A776B12C6D65AF2C6B47A1DB480A5F0BE83"
                                    description="Description"
                                    flags="adults"
                                    categoryTitle="Workplace Health Solutions"
                                    mediaLink=""
                                    downloadLink=""
                                    ></aha-selection-card>
                <aha-selection-card id="{5EBE375B-9E65-42F3-A035-BFCB07A12466}"
                                    title="Become a Heart Walk Hero"
                                    img="https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/imagination.png?h=200&amp;w=250&amp;hash=E24C1F60810D8C6E0A31E73E8A239723272BE3A7"
                                    description="Description"
                                    flags="adults"
                                    categoryTitle="Heart Walk"
                                    mediaLink=""
                                    downloadLink=""
                                    ></aha-selection-card>
                <aha-selection-card id="{802DF99C-4A49-4740-985D-5B67F110CEF7}"
                                    title="Host a fundraiser"
                                    img="https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/wall_post.png?h=200&amp;w=274&amp;hash=5A2988A77F04B10FC26CB128B9A14CD02F3F4571"
                                    description="Description"
                                    flags="adults"
                                    categoryTitle="Fundraiser"
                                    mediaLink=""
                                    downloadLink=""
                                    ></aha-selection-card>
                <aha-selection-card id="{560173C2-053D-40D6-848B-63F55578A0CE}"
                                    title="Help Women in Your Community Live Healthier Lives"
                                    img="https://sitecoredev.heart.org/-/media/images/health-topics/congenital-heart-defects/happy-young-father-looking-with-tenderness-at-his-pjbdgt2.jpg?h=1125&amp;w=2000&amp;hash=31FD8EDB57796AC461BD6AF9BCA56A85DF4E54B0"
                                    description="Description"
                                    flags="adults"
                                    categoryTitle="Workplace Health Solutions"
                                    mediaLink=""
                                    downloadLink=""
                                    ></aha-selection-card>
                <aha-selection-card id="{F3892D66-5889-47AD-91B9-E1B80BBC1E9E}"
                                    title="Join the GRFW health"
                                    img="https://sitecoredev.heart.org/-/media/images/professional/quality-improvement/black-female-doctor-leading-medical-team-pv89ysg-copy.jpg?h=1272&amp;w=2000&amp;hash=FD652FDAF85F3331AB6278666B154EEA96A54505"
                                    description="Description"
                                    flags="adults"
                                    categoryTitle="Workplace Health Solutions"
                                    mediaLink=""
                                    downloadLink=""
                                    ></aha-selection-card>
                <aha-selection-card id="{35771D0F-8FCA-42FA-9940-BEAE581D6E9D}"
                                    title="Teach Healthy Eating Habits to Your Community"
                                    img="https://sitecoredev.heart.org/-/media/images/istock_000014401432_full.jpg?h=2799&amp;w=4201&amp;hash=4AB06532757A888F056BF1D0D63B9FC02BA4BA11"
                                    description="Description"
                                    flags="adults"
                                    categoryTitle="Hands only CPR"
                                    mediaLink=""
                                    downloadLink=""
                                    ></aha-selection-card>
                <aha-selection-card id="{0DEB1773-24BA-4674-B1F3-ADC03951237F}"
                                    title="Start a High School Service Hub ML"
                                    img="https://sitecoredev.heart.org/-/media/images/professional/quality-improvement/doctorwithstethoscopep3h5abz.jpg?h=1125&amp;w=2000&amp;hash=85374FA1F8549FACF42BB23FBAEBE92FCB935F2C"
                                    description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta."
                                    flags="youth"
                                    categoryTitle="Heart Walk"
                                    mediaLink="https://sitecoredev.heart.org/en/help-me-choose" 
                                    mediaLinkDescription="How to Hands-Only CPR <br> 1:23 min"
                                    mediaTitle="Media Title"
                                    mediaText="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta."
                                    downloadLink=""
                                    downloadButtonText=""
                                    ></aha-selection-card>
                <aha-selection-card id="{C70DB700-CD08-4282-B08D-5FD892E2F60E}"
                                    title="Learn to save lives DL"
                                    img="https://sitecoredev.heart.org/-/media/images/volunteer-opportunities/super_woman.png?h=201&amp;w=224&amp;hash=F371DE7C2E494960F76232ECACE65B7C56FE7E91"
                                    description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta."
                                    flags="youth"
                                    categoryTitle="Fundraiser"
                                    mediaTitle="Media Title"
                                    mediaText="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid ut expedita quas voluptas praesentium tenetur eligendi et accusamus, at similique? Neque quidem accusamus voluptatem commodi ea inventore repellat culpa soluta." 
                                    mediaLink=""
                                    mediaLinkDescription=""
                                    downloadLink="https://sitecoredev.heart.org/en/help-me-choose"
                                    downloadButtonText="Download Your Toolkit"
                                    ></aha-selection-card>
                                                
                <!-- IE doesn't like this. Don't know why -->
                <!--<template v-slot:actions="{ valid, submit }" >
                    <div class="row justify-content-center mb-5">
                        <a class="btn btn-round btn-outline-dark mr-3" 
                            href="https://sitecoredev.heart.org/en/help-me-choose" target="_blank" src="link">
                            Help Me Choose</a> 
                        <a class="btn btn-primary btn-round" :class="{ 'disabled': !valid }" href="/en/demos/volunteer-form/your-info" v-on:click.prevent="submit($event)">Next</a></div>
                </template>-->
                <!-- Modified with slot-scope and props -->
                <!-- props.submit($event) to resolve Safari/Mobile not loading the loadingModal -->
                <!-- Stop the form submitting, fire the loadingModal then submit the form -->
                
                <template slot="actions" slot-scope="props">
                    <a src="link"
                        target="_blank"
                        href="https://sitecoredev.heart.org/en/help-me-choose"
                        class="btn btn-round btn-outline-dark mr-3">
                        Help Me Choose
                    </a>

                    <a v-if="props.isFiltered('youth')" class="btn btn-primary btn-round"
                        :class="{ 'disabled': !props.valid }"
                        href="/en/demos/volunteer-form/consent"
                        v-on:click.prevent="props.submit($event)">
                        Next
                    </a>

                    <a v-else class="btn btn-primary btn-round"
                        :class="{ 'disabled': !props.valid }"
                        href="/en/demos/volunteer-form/your-info"
                        v-on:click.prevent="props.submit($event)">
                        Next
                    </a>
                </template>

            </aha-card-selector>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form>
                    <input type="hidden" name="selectedOpps" v-from-store:card-selector="'selectedIds'">
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <aha-card-viewer-text v-slot="{count}">
                    <h1>GREAT! You choose {{count}} {{ 'Opportunity' | pluralize(count) }}</h1>
                </aha-card-viewer-text>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <aha-switch-input aria-describedby="hello" name="democollapse" toggle-for="democollapse" />

                    <div class="col-md-6">
                  <fieldset>
                    <legend class="c-switch-input-legend" id="hello">
                        Are you active military or a military veteran?
                    </legend> 
                    <br class="d-lg-none">
                    <aha-switch-input name="ActiveMilitary" 
                                        aria-describedby="hello"
                                        toggle-for="ActiveMilitaryNarrative"
                                        on-text="Yes"
                                        off-text="No" >
                    </aha-switch-input>

                </fieldset>  
                </div>

                <div class="col-md-6">
                  <fieldset>
                    <legend class="input-switch-legend" id="hello">
                        Are you active military or a military veteran?
                    </legend> 
                    <br class="d-lg-none">
                    <aha-switch-input name="ActiveMilitary" 
                                        aria-describedby="hello"
                                        toggle-for="ActiveMilitaryNarrative"
                                        on-text="Yes"
                                        off-text="No" >
                    </aha-switch-input>

                </fieldset>  
                </div>


                <aha-collapsable-view :show="false" name="democollapse">
                    <aha-card-viewer-text>
                        <h1>GREAT! You choose {count} Opportunities</h1>
                    </aha-card-viewer-text>
                </aha-collapsable-view>
            </div>
        </div>
        <!-- <h5>demo</h5> -->
        <div class="row">
            <div class="col-12 col-md-5" styles="background: 'green'; height: 685px;">
                <aha-card-viewer mode="stack" />
            </div>
        </div>
        <div class="row">
            <div class="col-12" styles="background: 'yellow';">
                <aha-card-viewer mode="list" />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h4>bottom</h4>
                <input type="text" v-aha-mask="'phone'" />
                <input type="text" v-aha-mask="'date'" />
            </div>
        </div>

        <aha-modal ref="loadingModal" size="md" id="loadingModal" class="c-loadingModal" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered lazy>
            <template slot="modal-header">
                <div class="c-loadingModal__heading ">Submitting Form</div>
            </template>
            <div class="loader-container show" role="alert" aria-live="assertive">
                <div class="loader">Loading...</div>
            </div>
            <p class="text-center">
                Please be patient while we are submitting your form.
            </p>
        </aha-modal>
    </div>
</template>
<script>
import { BFormDatepicker } from 'bootstrap-vue'
export default {
    components: {
        BFormDatepicker
    }
}
</script>



// WEBPACK FOOTER //
// demo/pages/components/card-selector.vue